<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <div v-if="!$apollo.queries.osdaUsers.loading">
          <b-card class="mb-4">
            <b-button variant="primary" :to="{ name: 'settings.users.osda.create'}">
              <font-awesome-icon icon="plus-circle" />สร้างบัญชีเจ้าหน้าที่
            </b-button>
          </b-card>

          <user-list-table :users="osdaUsers.data" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import UserListTable from '@/components/settings/users/osda/UserListTable'
import gql from 'graphql-tag'

export default {
  components: {
    UserListTable
  },
  apollo: {
    osdaUsers: {
      query: gql`{ osdaUsers (count: 100) { data { id, thFullName, username, email } } }`
    }
  }
}
</script>
